// Insignia circular tipo sello de pasaporte
export const PassportStamp = ({
  code = "MEX",
  label = "VISITADO",
  color = "#E8C547",
  rotate = -12,
  size = 96,
  className = "",
}) => {
  const id = "stamp-" + code + Math.round(Math.random() * 1000);
  return (
    <div
      className={"relative select-none " + className}
      style={{ width: size, height: size, transform: `rotate(${rotate}deg)` }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 120 120" width={size} height={size}>
        <defs>
          <path
            id={id}
            d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0"
            fill="none"
          />
        </defs>
        <circle
          cx="60"
          cy="60"
          r="56"
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeDasharray="4 5"
        />
        <circle cx="60" cy="60" r="46" fill="none" stroke={color} strokeWidth="2" />
        <text
          fill={color}
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "2px",
          }}
        >
          <textPath href={"#" + id} startOffset="0%">
            {`${label} · ${label} · `}
          </textPath>
        </text>
        <text
          x="60"
          y="68"
          textAnchor="middle"
          fill={color}
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "26px",
            fontWeight: 700,
            letterSpacing: "1px",
          }}
        >
          {code}
        </text>
      </svg>
    </div>
  );
};
